export const explainPairingScreen = `
Browse to https://dashboard.castreactor.com/connect using the kiosk web browser 
of you device 

Get a Code and then add it in the below form proving also a name for your screen

![image info](/static/screenShot/Cast-Reactor-Add-Screen.png)
`
